import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Input,
  FormGroup,
  Col,
  Row,
  Container,
  Label,
} from "reactstrap";
import ApiCaller from "api/apiCaller";
import { ScheduleQuery } from "model/schedule_query";

interface ScheduleQueryItemProps {
  scheduleQueryData: ScheduleQuery;
  companyName?: string;
}

export default function ScheduleQueryItem({
  scheduleQueryData,
  companyName,
}: ScheduleQueryItemProps) {
  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div>
          <a href={`/schedule_query/${scheduleQueryData?.id}`}>
            <span style={styles.name}>{scheduleQueryData?.name}</span>
          </a>
          <span
            style={{
              backgroundColor: scheduleQueryData?.is_active ? "green" : "red",
              color: "white",
              padding: 5,
              borderRadius: 20,
              marginLeft: 10,
              fontSize: 12
            }}
          >
            {scheduleQueryData?.is_active ? "Enable" : "Disable"}
          </span>
        </div>
        <span style={styles.projectName}>{companyName}</span>
      </div>
      <div style={styles.info}>
        <span>Destination dataset: {scheduleQueryData?.dataset_name}</span>
        <br />
        <span>Destination table: {scheduleQueryData?.table_name}</span>
        <br />
        <span>Description: {scheduleQueryData?.description}</span>
        <br />
        <span>Schedule (UTC): {scheduleQueryData?.schedule_time}</span>
        <br />
        <br />
      </div>
    </div>
  );
}

const styles: { [name: string]: React.CSSProperties } = {
  container: {
    padding: 12,
    border: "1px solid var(--color-line)",
    borderRadius: 4,
  },
  name: {
    fontSize: 18,
    fontWeight: 500,
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
  },
  projectName: {
    fontSize: 16,
    padding: 6,
    color: "var(--color-accent-dark)",
    fontWeight: 500,
  },
  info: {
    fontSize: 14,
    color: "var(--secondary)",
  },
};
